import classNames from 'classnames'
import React from 'react'

interface PhoneIconProps {
	size?: 'sm' | 'md' | 'lg'
	color?: 'brand' | 'gray'
}

const PhoneIcon: React.FC<PhoneIconProps> = ({ size = 'lg', color = 'brand' }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		className={classNames({
			'w-4 h-4': size === 'sm',
			'w-5 h-5': size === 'md',
			'w-6 h-6': size === 'lg',
		})}
		fill="none"
		viewBox="0 0 13 12"
	>
		<path
			className={classNames({
				'fill-brand-primary-md': color === 'brand',
				'fill-brand-gray-300': color === 'gray',
			})}
			d="M11.997 9.47a.58.58 0 01-.178.509l-1.69 1.677a.95.95 0 01-.298.216c-.123.06-.244.098-.362.114l-.076.007a1.701 1.701 0 01-.166.006c-.16 0-.421-.027-.781-.082-.36-.056-.8-.191-1.322-.407-.52-.216-1.112-.54-1.772-.972-.661-.432-1.364-1.025-2.11-1.78a13.924 13.924 0 01-1.474-1.676 11.951 11.951 0 01-.94-1.48 7.973 7.973 0 01-.534-1.233 6.54 6.54 0 01-.241-.953 3.147 3.147 0 01-.05-.63l.012-.253c.017-.119.055-.24.114-.363a.952.952 0 01.216-.298l1.69-1.69a.56.56 0 01.407-.178c.11 0 .207.032.292.095a.883.883 0 01.216.235l1.36 2.58a.618.618 0 01.063.445.792.792 0 01-.216.406l-.622.623a.212.212 0 00-.045.082.314.314 0 00-.019.096c.034.178.11.38.229.61.101.203.258.45.47.743.212.292.512.629.902 1.01.381.39.72.693 1.017.909.296.216.544.375.743.476.2.102.352.163.458.184l.158.032a.303.303 0 00.083-.019.212.212 0 00.083-.044l.724-.737a.778.778 0 01.534-.204c.144 0 .258.026.343.077h.012L11.68 9.05c.178.11.284.25.317.42z"
		/>
	</svg>
)

export default PhoneIcon
